// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".leaflet-container {\n    width: 75vw;\n    height: 70vh;\n    z-index: 0;\n}", "",{"version":3,"sources":["webpack://./src/components/pages/reports/react-leaflet.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;AACd","sourcesContent":[".leaflet-container {\n    width: 75vw;\n    height: 70vh;\n    z-index: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
